export default {
  loggedIn (state) {
    return state.isLoggedIn
  },

  authenticatedUser (state) {
    return state.user
  },

  getRoomDialogOpen (state) {
    return state.roomDialogOpen
  },
}
